import { ExclamationCircleIcon } from "@heroicons/react/outline";
import { FC } from "react";

import { ErrorMessageProps } from "./types";

const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <div className="mt-6 max-h-[500px] overflow-y-auto rounded-md border border-red-300 bg-red-50 p-4">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <ExclamationCircleIcon className="h-6 w-6 text-red-500" aria-hidden="true" />
        </div>
        <div className="ml-4">
          <h3 className="text-lg font-medium text-red-800">Error</h3>
          <div className="mt-2 text-base text-red-700">
            <p>{message}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
